import { formatDate } from 'shared/lib/formatDate';

export function getDateAndTimeFromDeadline(deadlineString: string) {
  const deadlineDate = new Date(deadlineString);

  const date = formatDate(deadlineDate);
  const hours = String(deadlineDate.getHours()).padStart(2, '0');
  const minutes = String(deadlineDate.getMinutes()).padStart(2, '0');
  const time = `${hours}:${minutes}`;

  return `${date} ${time}`;
}
